<template>
    <div class="hero">
        <div class="hero-head">
            <Navbar />
        </div>
        <div class="hero-body">
            <Logo class="logo block"/>
            <p class="is-size-3 text has-text-white block has-text-centered">4,444 GENERATIVE HAND-DRAWN LAMP PROFILES</p>
            <p class="is-size-5 text has-text-weight-bold has-text-white block has-text-centered">Head to OpenSea to get your persona lamp.</p>
            <div class="buttons-container">
                <a href="https://opensea.io/collection/persona-lamps">
                    <button class="button opensea">
                        <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.5 0C10.0755 0 0 10.0755 0 22.5C0 34.9245 10.0755 45 22.5 45C34.9245 45 45 34.9245 45 22.5C45 10.0755 34.929 0 22.5 0ZM11.1015 23.256L11.196 23.103L17.0505 13.9455C17.136 13.815 17.3385 13.8285 17.4015 13.9725C18.378 16.164 19.224 18.891 18.828 20.5875C18.6615 21.285 18.198 22.23 17.676 23.103C17.6085 23.229 17.5365 23.355 17.4555 23.4765C17.4195 23.5305 17.3565 23.562 17.289 23.562H11.2725C11.1105 23.562 11.016 23.3865 11.1015 23.256ZM37.188 26.406C37.188 26.4915 37.1385 26.5635 37.0665 26.595C36.612 26.7885 35.0595 27.504 34.416 28.3995C32.769 30.69 31.5135 33.966 28.701 33.966H16.974C12.816 33.966 9.45 30.5865 9.45 26.415V26.28C9.45 26.172 9.54 26.082 9.6525 26.082H16.1865C16.317 26.082 16.4115 26.199 16.4025 26.3295C16.353 26.7525 16.434 27.189 16.6365 27.585C17.0235 28.3725 17.829 28.863 18.6975 28.863H21.933V26.3385H18.7335C18.5715 26.3385 18.4725 26.1495 18.567 26.0145C18.603 25.9605 18.639 25.9065 18.684 25.8435C18.9855 25.4115 19.4175 24.7455 19.8495 23.985C20.142 23.472 20.4255 22.923 20.655 22.374C20.7 22.275 20.736 22.1715 20.7765 22.0725C20.8395 21.897 20.9025 21.7305 20.9475 21.5685C20.9925 21.429 21.033 21.285 21.069 21.15C21.177 20.682 21.222 20.187 21.222 19.674C21.222 19.4715 21.213 19.26 21.195 19.062C21.186 18.8415 21.159 18.621 21.132 18.4005C21.114 18.207 21.078 18.0135 21.042 17.8155C20.9925 17.523 20.9295 17.2305 20.8575 16.938L20.8305 16.8255C20.7765 16.623 20.727 16.434 20.664 16.2315C20.4795 15.6015 20.2725 14.985 20.0475 14.409C19.9665 14.1795 19.8765 13.959 19.782 13.743C19.647 13.41 19.5075 13.1085 19.3815 12.825C19.314 12.6945 19.26 12.5775 19.206 12.456C19.143 12.321 19.08 12.186 19.0125 12.0555C18.9675 11.9565 18.9135 11.862 18.8775 11.772L18.4815 11.043C18.4275 10.944 18.5175 10.8225 18.6255 10.854L21.1005 11.5245H21.1095C21.114 11.5245 21.114 11.5245 21.1185 11.5245L21.4425 11.619L21.8025 11.718L21.933 11.754V10.287C21.933 9.576 22.5 9 23.2065 9C23.5575 9 23.877 9.144 24.102 9.378C24.3315 9.612 24.4755 9.9315 24.4755 10.287V12.4695L24.741 12.5415C24.759 12.5505 24.7815 12.5595 24.7995 12.573C24.8625 12.618 24.957 12.69 25.074 12.78C25.1685 12.852 25.2675 12.942 25.3845 13.0365C25.623 13.23 25.911 13.4775 26.2215 13.761C26.3025 13.833 26.3835 13.905 26.46 13.9815C26.8605 14.355 27.3105 14.7915 27.7425 15.2775C27.864 15.417 27.981 15.552 28.1025 15.7005C28.2195 15.849 28.35 15.993 28.458 16.137C28.6065 16.3305 28.7595 16.533 28.899 16.7445C28.962 16.8435 29.0385 16.947 29.097 17.046C29.277 17.3115 29.43 17.586 29.5785 17.8605C29.6415 17.9865 29.7045 18.126 29.7585 18.261C29.925 18.63 30.0555 19.0035 30.1365 19.3815C30.1635 19.4625 30.1815 19.548 30.1905 19.629V19.647C30.2175 19.755 30.2265 19.872 30.2355 19.9935C30.2715 20.376 30.2535 20.763 30.1725 21.15C30.1365 21.312 30.0915 21.465 30.0375 21.6315C29.979 21.789 29.925 21.951 29.853 22.1085C29.7135 22.428 29.5515 22.752 29.358 23.049C29.295 23.1615 29.2185 23.2785 29.1465 23.391C29.0655 23.508 28.98 23.6205 28.908 23.7285C28.8045 23.868 28.6965 24.012 28.584 24.1425C28.485 24.2775 28.386 24.4125 28.2735 24.534C28.1205 24.7185 27.972 24.8895 27.8145 25.056C27.7245 25.164 27.6255 25.2765 27.522 25.3755C27.423 25.488 27.3195 25.587 27.2295 25.677C27.072 25.8345 26.946 25.9515 26.838 26.055L26.5815 26.2845C26.5455 26.3205 26.496 26.3385 26.4465 26.3385H24.4755V28.863H26.955C27.5085 28.863 28.035 28.6695 28.4625 28.305C28.6065 28.179 29.241 27.63 29.9925 26.802C30.0195 26.7705 30.051 26.7525 30.087 26.7435L36.9315 24.7635C37.062 24.7275 37.188 24.822 37.188 24.957V26.406Z" fill="white"/>
                        </svg>
                        <p class="button-text ">Check on OpenSea</p>
                    </button>
                </a>
                <button class="button metamask" @click="connectWallet" v-if="!currAccount">                   
                    <svg width="45" height="40" viewBox="0 0 45 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_100_2295)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8951 36.3971L18.7457 37.9334V35.9244L19.2233 35.4517H22.5665V37.8151V39.4695H18.9845L14.5666 37.5788L12.8951 36.3971Z" fill="#CDBDB2"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M31.9988 36.3971L26.2677 37.9334V35.9244L25.7901 35.4517H22.4469V37.8151V39.4695H26.0289L30.4465 37.5788L31.9988 36.3971Z" fill="#CDBDB2"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2233 32.0248L18.7457 35.9244L19.3426 35.4517H25.5513L26.2677 35.9244L25.7901 32.0248L24.8349 31.4338L20.059 31.5521L19.2233 32.0248Z" fill="#393939"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9994 5.67226L18.865 12.2899L20.1785 31.5521H24.8349L26.2677 12.2899L28.8945 5.67226H15.9994Z" fill="#F89C35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.46267 20.2076L0.119507 29.7794L8.47741 29.3067H13.8502V25.1708L13.6114 16.6624L12.4175 17.6078L3.46267 20.2076Z" fill="#F89D35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.79068 21.271L19.5814 21.5074L18.5069 26.4706L13.8502 25.2889L9.79068 21.271Z" fill="#D87C30"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.79068 21.3893L13.8502 25.1708V28.9523L9.79068 21.3893Z" fill="#EA8D3A"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8502 25.2889L18.6262 26.4706L20.1785 31.5521L19.1038 32.1429L13.8502 29.0704V25.2889Z" fill="#F89D35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8502 29.0704L12.8951 36.3971L19.2233 32.0248L13.8502 29.0704Z" fill="#EB8F35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5814 21.5074L20.1785 31.5521L18.3874 26.4116L19.5814 21.5074Z" fill="#EA8E3A"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.35791 29.1887L13.8502 29.0704L12.8951 36.3971L8.35791 29.1887Z" fill="#D87C30"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.74628 39.5878L12.895 36.3971L8.3579 29.1887L0.119507 29.7794L2.74628 39.5878Z" fill="#EB8F35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.865 12.2899L13.7309 16.5441L9.79068 21.271L19.5814 21.6256L18.865 12.2899Z" fill="#E8821E"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8951 36.3971L19.2233 32.0248L18.7457 35.8063V37.9334L14.4473 37.1061L12.8951 36.3971Z" fill="#DFCEC3"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M31.9988 36.3971L25.7901 32.0248L26.2677 35.8063V37.9334L30.566 37.1061L31.9988 36.3971Z" fill="#DFCEC3"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9546 23.6345L18.2681 26.3525L13.6114 25.1708L16.9546 23.6345Z" fill="#393939"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.62677 0.118279L18.865 12.2899L16.1189 5.67227L2.62677 0.118279Z" fill="#E88F35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.62677 0.118172L0.4776 6.61765L1.67159 13.708L0.835796 14.1807L2.02978 15.2442L1.07459 16.0714L2.38798 17.2532L1.55219 17.9622L3.46256 20.3256L12.4175 17.6077C16.7954 14.1413 18.9446 12.3687 18.865 12.2899C18.7854 12.2111 13.3726 8.15389 2.62677 0.118172Z" fill="#8E5A30"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M41.4312 20.2076L44.7744 29.7794L36.4165 29.3067H31.0436V25.1708L31.2824 16.6624L32.4764 17.6078L41.4312 20.2076Z" fill="#F89D35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M35.1032 21.271L25.3125 21.5074L26.387 26.4706L31.0436 25.2889L35.1032 21.271Z" fill="#D87C30"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M35.1032 21.3893L31.0436 25.1708V28.9523L35.1032 21.3893Z" fill="#EA8D3A"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M31.0436 25.2889L26.2677 26.4706L24.7154 31.5521L25.7901 32.1429L31.0436 29.0704V25.2889Z" fill="#F89D35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M31.0437 29.0704L31.9988 36.3971L25.7901 32.1429L31.0437 29.0704Z" fill="#EB8F35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M25.3125 21.5074L24.7154 31.5521L26.5065 26.4116L25.3125 21.5074Z" fill="#EA8E3A"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M36.536 29.1887L31.0436 29.0704L31.9988 36.3971L36.536 29.1887Z" fill="#D87C30"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M42.1476 39.5878L31.9988 36.3971L36.536 29.1887L44.7744 29.7794L42.1476 39.5878Z" fill="#EB8F35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M26.0289 12.2899L31.1629 16.5441L35.1032 21.271L25.3125 21.6256L26.0289 12.2899Z" fill="#E8821E"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.9393 23.6345L26.6258 26.3525L31.2824 25.1708L27.9393 23.6345Z" fill="#393939"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M42.2671 0.118279L26.0289 12.2899L28.775 5.67227L42.2671 0.118279Z" fill="#E88F35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M42.2671 0.118172L44.4163 6.61765L43.2223 13.708L44.0581 14.1807L42.8641 15.2442L43.8193 16.0714L42.5059 17.2532L43.3417 17.9622L41.4313 20.3256L32.4764 17.6077C28.0985 14.1413 25.9493 12.3687 26.0289 12.2899C26.1085 12.2111 31.5212 8.15389 42.2671 0.118172Z" fill="#8E5A30"/>
                        </g>
                    </svg>
                    <p class="button-text">Connect Wallet</p>
                </button>
                <button class="button metamask" v-else>
                    <svg width="45" height="40" viewBox="0 0 45 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_100_2295)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8951 36.3971L18.7457 37.9334V35.9244L19.2233 35.4517H22.5665V37.8151V39.4695H18.9845L14.5666 37.5788L12.8951 36.3971Z" fill="#CDBDB2"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M31.9988 36.3971L26.2677 37.9334V35.9244L25.7901 35.4517H22.4469V37.8151V39.4695H26.0289L30.4465 37.5788L31.9988 36.3971Z" fill="#CDBDB2"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2233 32.0248L18.7457 35.9244L19.3426 35.4517H25.5513L26.2677 35.9244L25.7901 32.0248L24.8349 31.4338L20.059 31.5521L19.2233 32.0248Z" fill="#393939"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9994 5.67226L18.865 12.2899L20.1785 31.5521H24.8349L26.2677 12.2899L28.8945 5.67226H15.9994Z" fill="#F89C35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.46267 20.2076L0.119507 29.7794L8.47741 29.3067H13.8502V25.1708L13.6114 16.6624L12.4175 17.6078L3.46267 20.2076Z" fill="#F89D35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.79068 21.271L19.5814 21.5074L18.5069 26.4706L13.8502 25.2889L9.79068 21.271Z" fill="#D87C30"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.79068 21.3893L13.8502 25.1708V28.9523L9.79068 21.3893Z" fill="#EA8D3A"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8502 25.2889L18.6262 26.4706L20.1785 31.5521L19.1038 32.1429L13.8502 29.0704V25.2889Z" fill="#F89D35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8502 29.0704L12.8951 36.3971L19.2233 32.0248L13.8502 29.0704Z" fill="#EB8F35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5814 21.5074L20.1785 31.5521L18.3874 26.4116L19.5814 21.5074Z" fill="#EA8E3A"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.35791 29.1887L13.8502 29.0704L12.8951 36.3971L8.35791 29.1887Z" fill="#D87C30"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.74628 39.5878L12.895 36.3971L8.3579 29.1887L0.119507 29.7794L2.74628 39.5878Z" fill="#EB8F35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.865 12.2899L13.7309 16.5441L9.79068 21.271L19.5814 21.6256L18.865 12.2899Z" fill="#E8821E"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8951 36.3971L19.2233 32.0248L18.7457 35.8063V37.9334L14.4473 37.1061L12.8951 36.3971Z" fill="#DFCEC3"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M31.9988 36.3971L25.7901 32.0248L26.2677 35.8063V37.9334L30.566 37.1061L31.9988 36.3971Z" fill="#DFCEC3"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9546 23.6345L18.2681 26.3525L13.6114 25.1708L16.9546 23.6345Z" fill="#393939"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.62677 0.118279L18.865 12.2899L16.1189 5.67227L2.62677 0.118279Z" fill="#E88F35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.62677 0.118172L0.4776 6.61765L1.67159 13.708L0.835796 14.1807L2.02978 15.2442L1.07459 16.0714L2.38798 17.2532L1.55219 17.9622L3.46256 20.3256L12.4175 17.6077C16.7954 14.1413 18.9446 12.3687 18.865 12.2899C18.7854 12.2111 13.3726 8.15389 2.62677 0.118172Z" fill="#8E5A30"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M41.4312 20.2076L44.7744 29.7794L36.4165 29.3067H31.0436V25.1708L31.2824 16.6624L32.4764 17.6078L41.4312 20.2076Z" fill="#F89D35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M35.1032 21.271L25.3125 21.5074L26.387 26.4706L31.0436 25.2889L35.1032 21.271Z" fill="#D87C30"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M35.1032 21.3893L31.0436 25.1708V28.9523L35.1032 21.3893Z" fill="#EA8D3A"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M31.0436 25.2889L26.2677 26.4706L24.7154 31.5521L25.7901 32.1429L31.0436 29.0704V25.2889Z" fill="#F89D35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M31.0437 29.0704L31.9988 36.3971L25.7901 32.1429L31.0437 29.0704Z" fill="#EB8F35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M25.3125 21.5074L24.7154 31.5521L26.5065 26.4116L25.3125 21.5074Z" fill="#EA8E3A"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M36.536 29.1887L31.0436 29.0704L31.9988 36.3971L36.536 29.1887Z" fill="#D87C30"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M42.1476 39.5878L31.9988 36.3971L36.536 29.1887L44.7744 29.7794L42.1476 39.5878Z" fill="#EB8F35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M26.0289 12.2899L31.1629 16.5441L35.1032 21.271L25.3125 21.6256L26.0289 12.2899Z" fill="#E8821E"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.9393 23.6345L26.6258 26.3525L31.2824 25.1708L27.9393 23.6345Z" fill="#393939"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M42.2671 0.118279L26.0289 12.2899L28.775 5.67227L42.2671 0.118279Z" fill="#E88F35"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M42.2671 0.118172L44.4163 6.61765L43.2223 13.708L44.0581 14.1807L42.8641 15.2442L43.8193 16.0714L42.5059 17.2532L43.3417 17.9622L41.4313 20.3256L32.4764 17.6077C28.0985 14.1413 25.9493 12.3687 26.0289 12.2899C26.1085 12.2111 31.5212 8.15389 42.2671 0.118172Z" fill="#8E5A30"/>
                        </g>
                    </svg>
                    <p class="button-text">{{ currAccount.slice(0,11) }}...</p>
                </button>
            </div>
        </div>
        <div class="alert" :class="{'is-active': $store.state.showNotification}">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
            <div class="alert-text">
                <p class="has-text-weight-bold is-size-7">Whoops! Access denied.</p>
                <p class="is-size-7">The Webcomic is only visible by Lamp Holders, head to OpenSea to get yours.</p>
            </div>
            <button class="delete" @click="$store.state.showNotification = false"></button>
        </div>
    </div>
</template>

<script>
import { onBeforeMount } from '@vue/runtime-core'
import Logo from './Logo.vue'
import Navbar from './Navbar.vue'
import connectWallet from '@/functions/connectWallet'
import { getWallet, currAccount } from '@/functions/getWallet'

export default {
    name: 'Hero',
    components:{
        Navbar,
        Logo
    },
    setup(){
        onBeforeMount(()=>{
            getWallet()
        })
    return {connectWallet, currAccount}
    }
    
}
</script>

<style scoped>
.hero{
    position: relative;
    width: 100%;
    height: 100vh;
    background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 99.99%, rgba(0, 0, 0, 0) 100%), 
        url('../assets/hero.png');
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.hero-body{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.text{
    font-family: 'Rubik', sans-serif;
}
.buttons-container{
    display: flex;
}
.button{
    font-family: 'Montserrat', sans-serif;
    height: 58px;
    border-radius: 12px;
    width: 250px;
    transition: 300ms;
}
.button:hover{
    transform: scale(1.02);
}
.button-text{
    margin-left: 12px;
}
.opensea{
    background: #5D5FEF;
    border: none;
    color: white;
    margin-right: 8px;
}
.opensea:hover{
    color: white;
}
.metamask{
    background: white;
    border: 2px solid #9D9EF3;
    color:#5D5FEF;
}
.metamask:hover{
    color: #5D5FEF;
}
.button svg{
    width: 32px;
}
.logo{
    display: none;
    visibility: hidden;
}
.alert{
    visibility: hidden;
    display: none;
}
.alert.is-active{
    position: absolute;
    bottom: 5%;
    right: 2%;
    width: 500px;
    display: flex;
    color: #a5754a;
    background: #fefbec;
    border-radius: 12px;
    padding: 12px;
    animation: slideIn 0.8s ease-in;
    visibility: visible;
}
.alert svg{
    color: #fcbf39;
    max-width: 28px;
    margin-right: 8px;
}
/* tablet */
@media screen and (max-width: 1023px) {
    .hero-body{
        justify-content: center;
    }
    .logo{
        display: flex;
        visibility: visible;
        margin-bottom: 42px;
        width: 350px;
    }
}
/* mobile */
@media screen and (max-width: 768px){
    .hero-body{
        justify-content: flex-start;
    }
    .buttons-container{
        flex-direction: column;
    }
    .logo{
        width: 280px;
    }
    .opensea{
        margin-bottom: 24px;
    }
    .alert.is-active{
        position: absolute;
        bottom: 5%;
        right: 2%;
        width: 350px;
        display: flex;
        color: #a5754a;
        background: #fefbec;
        border-radius: 12px;
        padding: 12px;
        animation: slideIn 0.8s ease-in;
        visibility: visible;
    }
    .alert svg{
        color: #fcbf39;
        max-width: 28px;
        margin-right: 8px;
    }
}
</style>